<template>
  <div v-bind:class="$mq">
    <b-form-select class="child"
                   v-model="selected_daily"
                   v-bind:options="daily" />

    <b-form-select class="child"
                   v-model="selected_weekly"
                   v-bind:options="weekly" />

    <b-form-select class="child"
                   v-model="selected_monthly"
                   v-bind:options="monthly" />
  </div>
</template>

<script>
import config from '../../config'

function transform_data(period, data){
  var res = [{value : null, text : period}];
  data.forEach(function(d){
    res.push({value : d, text : d});
  })
  return res;
}

function get_reports(vue){
  vue.$http.get(config.DATA_URI + "/reports")
           .then(function(response){
             vue.daily   = transform_data('Daily',   response["body"][86400]);
             vue.weekly  = transform_data('Weekly',  response["body"][604800]);
             vue.monthly = transform_data('Monthly', response["body"][2629746]);
           });
}

export default {
  name: 'ReportSelector',

  data : function(){
    return {  selected_daily : null,
             selected_weekly : null,
            selected_monthly : null}
  },

  computed : {
    daily : {
      get : function(){
        return this.$store.state.report.reports.daily;
      },

      set : function(v){
        this.$store.commit('set_reports', {daily : v});
      }
    },

    weekly : {
      get : function(){
        return this.$store.state.report.reports.weekly;
      },

      set : function(v){
        this.$store.commit('set_reports', {weekly : v});
      }
    },

    monthly : {
      get : function(){
        return this.$store.state.report.reports.monthly;
      },

      set : function(v){
        this.$store.commit('set_reports', {monthly : v});
      }
    }
  },

  watch : {
    selected_daily : function(e){
      if(this.selected_daily == null) return;
      this.$store.commit('clear_report_data');
      this.$router.push("/report/day/" + this.selected_daily + "/" +
                        this.$store.state.report.section);
      this.$nextTick(function(){this.selected_daily = null});
    },

    selected_weekly : function(e){
      if(this.selected_weekly == null) return;
      this.$store.commit('clear_report_data');
      this.$router.push("/report/week/" + this.selected_weekly + "/" +
                        this.$store.state.report.section);
      this.$nextTick(function(){this.selected_weekly = null});
    },

    selected_monthly : function(e){
      if(this.selected_monthly == null) return;
      this.$store.commit('clear_report_data');
      this.$router.push("/report/month/" +
                        this.selected_monthly.replace("/", "-01-") + "/" +
                        this.$store.state.report.section);
      this.$nextTick(function(){this.selected_monthly = null});
    }
  },

  created : function(){
    get_reports(this);
  }
}
</script>

<style scoped>
.child{
  float: right;
  max-width: 20%;
  margin: 10px;
}
</style>
